import { WaitListItemSatus } from 'src/app/core/enums';



export class WaitlistFilterModel {
    constructor(
        public SchedulerIDs: number[],
        public FromDate?: Date,
        public ToDate?: Date,
        public Status?: WaitListItemSatus,
        ){  }

}
